
import React, { lazy, Suspense } from "react";
import { RouteObject } from "react-router-dom";

const Home = lazy(() => import("../pages/home/page"));
const Services = lazy(() => import("../pages/services/page"));
const FAQ = lazy(() => import("../pages/faq/page"));
const About = lazy(() => import("../pages/about/page"));
const Contact = lazy(() => import("../pages/contact/page"));
const NotFound = lazy(() => import("../pages/NotFound"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: (
      <Suspense fallback={null}>
        <Home />
      </Suspense>
    ),
  },
  {
    path: "/hizmetler",
    element: (
      <Suspense fallback={null}>
        <Services />
      </Suspense>
    ),
  },
  {
    path: "/sss",
    element: (
      <Suspense fallback={null}>
        <FAQ />
      </Suspense>
    ),
  },
  {
    path: "/hakkimizda",
    element: (
      <Suspense fallback={null}>
        <About />
      </Suspense>
    ),
  },
  {
    path: "/iletisim",
    element: (
      <Suspense fallback={null}>
        <Contact />
      </Suspense>
    ),
  },
  {
    path: "*",
    element: (
      <Suspense fallback={null}>
        <NotFound />
      </Suspense>
    ),
  },
];

export default routes;
